import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";

const isProduction = import.meta.env.VITE_APP_ENVIRONMENT === "production";

if (isProduction) {
  try {
    datadogRum.init({
      applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID || "",
      clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN || "",
      site: "datadoghq.com",
      service: "web-myoffice",
      env: "production",
      sessionSampleRate: 100,
      sessionReplaySampleRate: 0,
      defaultPrivacyLevel: "mask-user-input",
      trackViewsManually: false,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      allowedTracingUrls: [
        {
          match: /https:\/\/.*\.woba\.com\.br/,
          propagatorTypes: ["datadog", "tracecontext"],
        },
        {
          match: /https:\/\/.*\.beerorcoffee\.com/,
          propagatorTypes: ["datadog", "tracecontext"],
        },
      ],
      plugins: [reactPlugin({ router: true })],
    });
  } catch (error) {
    console.error("Failed to initialize Datadog RUM:", error);
  }
}

export const identifyDatadogUser = (user: {
  id: string;
  name?: string;
  email?: string;
  league?: number;
}) => {
  datadogRum.setUser(user);
};
